import axios from 'axios'
import qs from 'qs'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
import { getToken, removeToken } from '@/utils/auth'
import { Encrypt, Decrypt, uuid } from "@/utils/crypto.js"
import { Toast, Dialog } from 'vant';
let loadingInstance = null;
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  // 超时
  timeout: 120000,
  headers: {
    'App-PXX': 'H5',
    'App-Version': '1.0.9',
  }
})

if (getToken()) {
  window.uuids = getToken().substring(0, -16)
} else {
  window.uuids = uuid(16, 16)
}

// const CancelToken = axios.CancelToken;
// let uniqueRequst = new Map()

// request拦截器
service.interceptors.request.use(config => {
  loadingInstance = Toast.loading({
    duration: 0,
    message: '加载中...',
    forbidClick: true,
  });
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  } else {
    config.headers['User-ticket'] = window.uuids
  }
  
  let ignoreCryptHeaderKey = 'false'
  if (ignoreCryptHeaderKey != 'true' && config.method === 'post' && config.headers["Content_Type"] !== 'multipart/form-data' && config.headers["Content-Type"] !== 'multipart/form-data') {
    config.data = { ticketData: Encrypt(JSON.stringify(config.data), window.uuids) }
  }
  // config.headers['ignoreCrypt'] = true
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  loadingInstance.clear();
  const headToken = getToken();
  if (headToken) {
    window.uuids = headToken.substr(-16)
  }
  if (res.data.ticketData) {
    res.data.ticketData = Decrypt(res.data.ticketData, window.uuids)
    res.data = JSON.parse(res.data.ticketData)
  }
  if(res.config?.ignore){return res.data}
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = res.data.msg
  // 请求流类型,返回整个res
  if(code === 200 && res.request.responseType == 'blob' && res.config.downloadType == 'downloadExcel'){
    return res
  }
  // 返回json类型直接返回data
  else if (code === 200 && res.headers['content-type'] && res.headers['content-type'].indexOf('json') != -1) {
    return res.data
  }
  // 补回原来的判断
  else if(code === 200){
    return res.data
  }
  else if (code === 203) { // AjaxResult.error
    Toast.fail(msg);
    // Message({
    //   message: msg,
    //   type: 'error',
    //   duration: 2 * 1000
    // })
    return Promise.reject(msg)
  } else if (code === 401) {
    Toast.fail('登陆失效');
    // 判断是否已经在登录页？在登录页不提示这个
    let {pathname} = window.location
    if (pathname != "/login") {
      throttle(logAgin, 3000)
    }
  } else {
    Toast.fail(msg)
    // Message({
    //   message: msg,
    //   type: 'error',
    //   customClass: 'zIndex-2100',  // 为了正确显示于表单弹窗层级之上
    //   duration: 2 * 1000
    // })
    return Promise.reject(msg)
  }
},
  error => {
    loadingInstance.clear();
    console.log('err' + error)
    let { message } = error
    if (message == "Network Error") {
      message = "网络连接失败"
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时"
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常"
    }
    // message !== "cancel" && Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    Toast.fail(message);
    return Promise.reject(error)
  }
)
const logAgin = ()=>{
  Dialog.confirm({
    title: "系统提示",
    message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
  }).then(()=>{
    removeToken()
    window.location.hash = '#/login'
  });
  // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
  //   distinguishCancelAndClose: true,
  //   closeOnClickModal: false,
  //   closeOnPressEscape: false,
  //   showCancelButton:false,
  //   confirmButtonText: '重新登录',
  //   type: 'warning'
  // }
  // ).then(() => {
  //   store.dispatch('FedLogOut').then(() => {
  //     location.href = '/index'
  //   })
  // }).catch(action => {

  // });
}
const throttle = (function() {
  let timer = null
  // 这里返回的函数是每次用户实际调用的节流函数 
  return function(func, delay) {
    if (!timer) { //判断timer是否有值,如果没有则说明定时器不存在即可继续执行
      timer = setTimeout(() => { //关
        timer = null; //开
      }, delay)
      func.apply(this, arguments)
    }
  }
})()

export default service